import React, { useEffect, useState, useContext } from 'react'
import { Link } from 'react-router-dom'
import UserContext from '../../../config/UserContext'
import {
  HttpService,
  API,
  Title,
  PriceFormat,
  swal,
  Messages,
  toast,
  DateFormat
} from '../../../config/react'
import DataTable from 'react-data-table-component'

const MetalQuality = () => {
  const [MetalQualityList, setMetalQualityList] = useState([])
  const user = useContext(UserContext)
  const [isForceUpdate, setForceUpdate] = useState(false)

  const columns = [
    {
      name: 'Metal Quality',
      selector: (row) => row.metal_quality
    },
    {
      name: 'Fineness(%)',
      selector: (row) => row.fineness
    },
    {
      name: 'Rate',
      selector: (row) => <PriceFormat value={row.rate}></PriceFormat>
    },
    {
      name: 'Labour Charge',
      selector: (row) => <PriceFormat value={row.labour_charges}></PriceFormat>
    },
    {
      name: 'Created Date',
      selector: (row) => <DateFormat value={row.created_at}></DateFormat>
    },
    {
      name: 'Status',
      selector: (row) => (row.status === 1 ? <label>Active</label> : <label>Inactive</label>)
    },
    {
      name: 'Action',
      selector: (row) => (
        <div className="action-btn">
          <Link
            to={'/system/metalquality/edit/' + row.id}
            className="text-dark"
            title="Edit"
          >
            <i
              className="fa fa-pencil-square-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
          <Link
            onClick={(e) => DeleteMetalQuality(e, row.id)}
            to=""
            className="text-dark"
            title="Delete"
          >
            <i
              className="fa fa-trash-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
        </div>
      )
    }
  ]

  const DefaultFilters = {
    page: 1,
    search: '',
    page_size: 10
  }
  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)
  const [totalRows, settotalRows] = useState()

  useEffect(() => {
    document.title = Title.MetalQuality
    GetMetalQualityList()
  }, [CustomFilters])

  const GetMetalQualityList = () => {
    const passData = {
      page: CustomFilters.page,
      search: CustomFilters.search,
      page_size: CustomFilters.page_size
    }
    HttpService.postApi(API.GetMetalQualityAdminList, passData).then((response) => {
      if (response.data.status === true) {
        const data = response.data.result[1]
        // var data = response.data.result[0];

        setMetalQualityList(data)
        setForceUpdate(!isForceUpdate)
        settotalRows(response.data.result[0][0].total_row)
      }
    })
  }
  const handlePageChange = (e) => {
    setCustomFilters({ ...CustomFilters, page: e })
  }

  const handlePerRowsChange = (e) => {
    setCustomFilters({ ...CustomFilters, page_size: e })
  }

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <input
        type="text"
        title="Search For Metal Quality, Fineness(%)."
        className="form-control col-md-3"
        placeholder="Search"
        onChange={(e) => setCustomFilters({ ...CustomFilters, search: e.target.value })}
      />
    )
  })
  const DeleteMetalQuality = async (e, id) => {
    e.preventDefault()
    swal(Messages.SwalDeleteProp).then(function (isConfirm) {
      if (isConfirm) {
        const param = {
          id,
          IsDeleted: true,
          deleted_by: user.id
        }
        // console.log(param)
        HttpService.postApi(API.DeleteMetalQuality, param).then((response) => {
          // console.log(response)
          toast.success(Messages.RecordDeleted)
          GetMetalQualityList()
          setForceUpdate(!isForceUpdate)
        })
      }
    })
  }

  return (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> {Title.MetalQuality} </h3>
        <div className="btn-group">
          <Link
            to="/system/metalquality/add"
            className="btn btn-dark btn-fw rounded mr-2"
          >
            {' '}
            Add Metal Quality{' '}
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={MetalQualityList}
                  pagination
                  paginationServer
                  persistTableHead={true}
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  subHeader
                  subHeaderComponent={subHeaderComponentMemo}
                />

                {/* <MaterialTable
                                    title=""
                                    columns={[
                                        { title: 'Metal Quality', field: 'metal_quality' },
                                        { title: 'Fineness(%)', field: 'fineness' },
                                        {
                                            title: 'Rate', field: 'rate',
                                            render: rowData => <PriceFormat value={rowData.rate}></PriceFormat>
                                        },
                                        {
                                            title: 'Labour Charge', field: 'labour_charges',
                                            render: rowData => <PriceFormat value={rowData.labour_charges}></PriceFormat>
                                        },
                                        {
                                            title: 'Created Date', field: 'created_at', type: 'datetime',
                                            render: rowData => <DateFormat value={rowData.created_at}></DateFormat>
                                        },
                                        {
                                            title: 'Status', field: 'status',
                                            render: rowData => rowData.status == 1 ? <label>Active</label> : <label>Inactive</label>
                                        },
                                        {
                                            title: 'Action', field: 'id', className: "table_icon", sorting: false,
                                            render: rowData =>
                                                <div className="action-btn">
                                                    <Link to={"/system/metalquality/edit/" + rowData.id} className="text-dark" title="Edit"><i className="fa fa-pencil-square-o" aria-hidden="true"></i> </Link>
                                                    <Link onClick={e => DeleteMetalQuality(e, rowData.id)} to="" className="text-dark" title="Delete" ><i className="fa fa-trash-o" aria-hidden="true"></i> </Link>
                                                </div>
                                        }
                                    ]}

                                    data={MetalQualityList}
                                    options={{
                                        thirdSortClick: false,
                                        //exportButton: true,
                                        pageSize: 10,
                                        emptyRowsWhenPaging: false,
                                        thirdSortClick: false,
                                        //filtering: true,
                                        exportCsv: (columns, data) => {
                                            alert('You should develop a code to export ' + data.length + ' rows');
                                        },

                                    }}
                                /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MetalQuality
